import Vue from 'vue';
import {
    Button,
    Message,
    Row,
    Col,
    Form,
    FormItem,
    Input,
    Checkbox
} from 'element-ui';
import { VueAxios } from '@/plugins';
import i18n from '@/i18n';


//自定义样式
import '@/assets/scss/element-custom.scss';
import '@/assets/scss/fontawesome.scss';
import './login.scss';

import App from './App.vue';

import store from '@/store';

Vue.config.productionTip = false;
Vue.prototype.$message = Message;

Vue.use(Button);
Vue.use(Row);
Vue.use(Col);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Checkbox);
Vue.use(VueAxios);

window.app = new Vue({
    i18n,
    store,
    render: h => h(App)
}).$mount('#app');